import { useEffect, useState } from 'react'

import { useAtomValue } from 'jotai'

import { Text, GreyGrey70, Primary13Regular } from '@sequencehq/core-components'
import {
  customLocales,
  formatDistanceToNow,
  HOURS,
  SECONDS
} from '@sequencehq/utils/dates'

import { invoiceCalculatedAtAtom } from 'Invoices/atoms/invoiceEditing.atom'

export const LastRecalculated = () => {
  const calculatedAt = useAtomValue(invoiceCalculatedAtAtom)
  const [relativeTime, setRelativeTime] = useState<string | undefined>()

  useEffect(() => {
    if (!calculatedAt) return

    const dateCalculatedAt = new Date(calculatedAt)

    const updateRelativeTime = () => {
      setRelativeTime(
        formatDistanceToNow(dateCalculatedAt, {
          addSuffix: true,
          locale: customLocales.enGb
        })
      )
    }

    updateRelativeTime()

    const diff = new Date().getTime() - dateCalculatedAt.getTime()

    if (diff >= 1 * HOURS) return

    const interval = setInterval(updateRelativeTime, 30 * SECONDS)

    return () => clearInterval(interval)
  }, [calculatedAt])

  if (!calculatedAt) return null

  return (
    <Text
      {...Primary13Regular}
      color={GreyGrey70}
      marginRight="8px"
      data-testid="header.last-recalculated"
    >
      Last calculated {relativeTime}
    </Text>
  )
}
